import React from 'react';
import styles from './StandardOverview.module.css';

const Stat = ({ value, label }) => (
    <span className={styles.sinceLastVisitStat}>
        <strong>{value}</strong> {label}
    </span>
);

const SinceLastVisitBanner = ({ data }) => {
    if (!data) return null;

    return (
        <section className={styles.sinceLastVisitCard}>
            <p className={styles.cardEyebrow}>Since your last visit</p>
            <div className={styles.sinceLastVisitStats}>
                <Stat value={data.newDocuments} label="new documents" />
                <Stat value={data.irlResponses} label="IRL responses" />
                <Stat value={data.newObservations} label="new observations" />
                {data.intelligenceUpdates != null ? (
                    <Stat value={data.intelligenceUpdates} label="Intelligence updates" />
                ) : null}
            </div>
        </section>
    );
};

export default SinceLastVisitBanner;
